import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SplitCTA from "./components/SplitCTA";
import TrustSection from "./components/TrustSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureGrid from "./components/FeatureGrid";
import ArticlesSection from "./components/ArticlesSection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <SplitCTA />
        <TrustSection />
        <CategoryGrid />
        <FeatureGrid />
        <ArticlesSection />
        <TestimonialSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}